/**
 * PDF2 Slide 4 - Geográfico e Especialidades
 * Endpoint: /api/v1/visitas/dashboards/geografico/
 *
 * Filtros: SEM FILTRO DE TEMPO (dados acumulados)
 */
import { useState, useEffect } from "react";
import { Card, Row, Col, Spinner, Alert, Badge } from "react-bootstrap";
import { ResponsiveBar } from "@nivo/bar";
import api from "../../../services/api";

const Slide8GeograficoEspecialidades = ({ programaId, filters }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/visitas/dashboards/geografico/?programa_id=${programaId}`)
      .then(res => {
        if (res.data) {
          setData(res.data);
        } else {
          setData({ mapa_estados: [], especialidades: [] });
        }
      })
      .catch((err) => {
        setError(err.response?.data?.error || err.message);
      })
      .finally(() => setLoading(false));
  }, [programaId]);

  const labelAcumulado = "Dados Acumulados";

  if (loading) return <Spinner animation="border" className="d-block mx-auto my-4" />;

  if (error) {
    return (
      <Alert variant="warning" className="m-3">
        <strong>Seção 7 - Geográfico e Especialidades:</strong> {error}
      </Alert>
    );
  }

  const especialidadesArr = Array.isArray(data?.especialidades) ? data.especialidades : [];
  const hasEspecialidades = especialidadesArr.length > 0;

  return (
    <Row>
      {/* Mapa - temporariamente indisponível */}
      <Col md={6} className="mb-4">
        <Card className="h-100 border-0 shadow-sm">
          <Card.Header className="bg-white fw-bold border-0 d-flex justify-content-between align-items-center">
            <span>Médicos por Estado</span>
            <Badge bg="info" className="fw-normal">{labelAcumulado}</Badge>
          </Card.Header>
          <Card.Body
            style={{ height: "400px" }}
            className="d-flex align-items-center justify-content-center text-center px-4"
          >
            <div>
              <h6 className="text-muted mb-2">Mapa temporariamente indisponível</h6>
              <p className="text-muted small mb-0">
                Estamos trabalhando para restabelecer a visualização geográfica.
                Em breve esta seção voltará a exibir os dados normalmente.
              </p>
            </div>
          </Card.Body>
        </Card>
      </Col>

      {/* Especialidades Médicas - SEM FILTRO */}
      <Col md={6} className="mb-4">
        <Card className="h-100 border-0 shadow-sm">
          <Card.Header className="bg-white fw-bold border-0 d-flex justify-content-between align-items-center">
            <span>Especialidades Médicas (Ativos)</span>
            <Badge bg="info" className="fw-normal">{labelAcumulado}</Badge>
          </Card.Header>
          <Card.Body style={{ height: "400px" }}>
            {hasEspecialidades ? (
              <ResponsiveBar
                data={especialidadesArr}
                keys={["qtd"]}
                indexBy="especialidade"
                layout="horizontal"
                margin={{ top: 10, right: 40, bottom: 30, left: 150 }}
                padding={0.3}
                colors={["#5b9bd5"]}
                labelTextColor="#fff"
                axisLeft={{ tickSize: 0, tickPadding: 10 }}
                axisBottom={{ tickSize: 0, tickPadding: 5 }}
                enableGridX={true}
                enableGridY={false}
              />
            ) : (
              <div className="d-flex align-items-center justify-content-center h-100">
                <span className="text-muted">Sem registros disponíveis</span>
              </div>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

export default Slide8GeograficoEspecialidades;
